import { Pipe, PipeTransform, Injector } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({name: 'textMiddleEllipsis'})
export class TextMiddleEllipsisPipe implements PipeTransform {
    public constructor(private sanitized: DomSanitizer) {
    }
   
    transform(value: any, numberOfLetters:number=15, withExtension: boolean=true): any {
        //Rule: withExtension then it will get all extension letter included "." + 2 letter before "." as suffix else it will get last 5 letter as suffix
        //eg of suffix with extension: "fileName_20210730.pdf" will show "30.pdf"
        //eg of suffix without extension:"fileName_20210730" will show "10730"
        let result:string = value as string;
        //numberOfLetters is mean the text pass in exceed the number of letters so it will process the text else return full text
        if (result.length > numberOfLetters) {
            if (withExtension) {
                return this.sanitized.bypassSecurityTrustHtml(`
                <div style='display:inline-flex;flex-wrap:nowrap;max-width: 100%;'>
                    <div style='flex: 0 1 auto;text-overflow: ellipsis;overflow:hidden;white-space:nowrap;'>
                        ${result.substring(0, result.lastIndexOf(".") - 2)}</div>
                    <div style='flex: 1 0 auto;white-space: nowrap;'>${result.substring(result.lastIndexOf(".") - 2)}</div>
                </div>`);
            } else {
                return this.sanitized.bypassSecurityTrustHtml(`
                <div style='display:inline-flex;flex-wrap:nowrap;max-width: 100%;'>
                    <div style='flex: 0 1 auto;text-overflow: ellipsis;overflow:hidden;white-space:nowrap;'>
                        ${result.substring(0, result.length - 5)}</div>
                    <div style='flex: 1 0 auto;white-space: nowrap;'>${result.substring(result.length - 5)}</div>
                </div>
                `);
            }
        } else {
            return this.sanitized.bypassSecurityTrustHtml(`
            <div style='display:inline-flex;flex-wrap:nowrap;max-width: 100%;'>
                <div style='flex: 0 1 auto;text-overflow: ellipsis;overflow:hidden;white-space:nowrap;'>${result}</div>
            </div>
            `);
        }
    }
}